// Plus offer (features 10/16, the weeks 5-6 pay test without handling money): a $10/month card with "I'd join" and
// "Not now". It charges nothing and asks for no payment details; it only records intent. Tonight that is an app_events
// row with the already-allowed name 'feedback' and props {kind:'plus_intent', choice, price, surface} (a new event name
// would need a migration). metrics_daily counts the feedback TABLE, not these rows, so the habit numbers are untouched.
// Behind the plus_offer flag (OFF in production until alvin turns it on). Shown in Settings, and as a soft card after
// the 3rd calendar add, at most once a week.
import { supabase, track } from './api'
import { qaPreset, qaState } from './flags'

export const PLUS_PRICE = 10
const SEEN = 'mg_plus_seen' // localStorage: when the soft card last showed (ms)
const WEEK = 7 * 86400e3
export const PLUS_AFTER_ADDS = 3

export type PlusSurface = 'settings' | 'after_add'

/** Calendar adds this person has made (the QA presets pretend a count; nothing is written). */
export async function calendarAddCount(): Promise<number> {
  const p = qaPreset()
  if (p === 'first_add') return 1
  if (p === 'third_add') return PLUS_AFTER_ADDS
  if (p === 'checkin') return qaState().adds
  const { data } = await supabase.auth.getSession()
  const uid = data.session?.user.id
  if (!uid) return 0
  const { count, error } = await supabase.from('calendar_adds').select('id', { count: 'exact', head: true }).eq('user_id', uid)
  return error ? 0 : count ?? 0
}

/** May the soft card show now? 3+ adds and not shown in the last week (a QA preset always shows it). */
export function plusDue(adds: number, now = Date.now()): boolean {
  if (adds < PLUS_AFTER_ADDS) return false
  if (qaPreset() === 'third_add') return true
  let last = 0
  try { last = Number(localStorage.getItem(SEEN) ?? 0) || 0 } catch { /* never shown */ }
  return now - last >= WEEK
}
export function markPlusSeen(now = Date.now()) { try { localStorage.setItem(SEEN, String(now)) } catch { /* shows again next time */ } }

/** One row per answer; a QA session tags it so metrics skip it. */
export function recordPlus(choice: 'join' | 'not_now', surface: PlusSurface) {
  track('feedback', { kind: 'plus_intent', choice, price: PLUS_PRICE, surface, ...(qaState().on ? { qa: true } : {}) })
}
